import { useState, useContext } from "react";
import context from "../../store/context";
import SaveIcon from "../icons/Save";
import SavedIcon from "../icons/Saved";

const SaveUnsave = (props) => {
  const [isSaving, setIsSaving] = useState(false);
  const { setSavedCount, setTenders } = useContext(context);
  const [isSaved, setIsSaved] = useState(
    Number(props.isSavedDB) === 1 ? true : false
  );
  const userToken = sessionStorage.getItem("token");

  const removeTenderById = (id) => {
    setTenders((prevTender) => {
      return prevTender.filter((tender) => tender.id !== id);
    });
  };

  const saveUnsave = () => {
    if (userToken) {
      setIsSaving(true);
      var headers = new Headers();
      headers.append("X-XSRF-TOKEN", "csrf-cookie");
      headers.append("Accept", "application/json");
      headers.append("Authorization", `Bearer ${userToken}`);

      var requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow",
      };

      fetch(
        `https://api.ichereta.com/api/client/save-unsave/${props.id}`,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            sessionStorage.clear();
            window.location.href = "/";
          }
          return response.json();
        })
        .then((result) => {
          setSavedCount(result.count);

          setTenders((prevData) => {
            const updatedArray = prevData.map((item) => {
              if (item.id === props.id) {
                return {
                  ...item,
                  is_saved: Number(item.is_saved) === 0 ? "1" : "0",
                };
              }
              return item;
            });
            return updatedArray;
          });

          setIsSaved(!isSaved);
          setIsSaving(false);

          if (props.currentPath === "/saved") {
            removeTenderById(props.id);
          }
        })
        .catch((error) => {
          setIsSaving(false);
          console.log("error", error);
        });
    } else {
      props.navigate();
    }
  };

  const isActive = isSaved && (isSaved || Number(props.isSavedDB) === 1);

  return (
    <button
      onClick={saveUnsave}
      disabled={isSaving}
      className={`flex items-center justify-center gap-2 text-xs font-semibold min-w-[88px] px-3 py-1.5 rounded-full transition-colors disabled:opacity-70 ${
        isActive
          ? "bg-[#664bc7]/10 text-[#664bc7]"
          : "bg-gray-50 text-[#664bc7] ring-1 ring-gray-200 hover:bg-[#664bc7]/10 hover:ring-[#664bc7]/20"
      }`}
    >
      {isSaving ? (
        <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full border-t border-[#664bc7] animate-spin"></div>
      ) : isActive ? (
        <SavedIcon styles="w-4 h-4 sm:w-5 sm:h-5" />
      ) : (
        <SaveIcon styles="w-4 h-4 sm:w-5 sm:h-5" />
      )}

      <span className="transition-all duration-200">
        {isActive ? "Saved" : "Save"}
      </span>
    </button>
  );
};

export default SaveUnsave;
